import React from "react";
import {z} from "zod";
import LoadingButton from '@mui/lab/LoadingButton';

import Form from "@/components/form/Form.jsx";
import {useForm} from "@/hooks/useForm.jsx";
import {useFavorite} from "@/hooks/useFavorite.jsx";
import InputContainer from "@/components/form/InputContainer.jsx";
import Input from '@/components/form/MUIInput.jsx';
import PasswordInput from '@/components/form/MUIPasswordInput.jsx';
import {DASHBOARD} from "@/constants/routes/index.jsx";
import {setGTMUserData} from "@/utils/setGTMUserData.jsx";

const schema = z.object({
    email: z.string().min(1, "Email is required"),
    password: z.string().min(1, "Password is required"),
});

export default function SignIn({onSubmitCallback}) {
    const {
        register,
        onSubmit,
        state,
        isValid,
        isLoading,
    } = useForm({
        endpoint: `/api/sign-in`,
        schema,
        defaultValues: {
            email: '',
            password: '',
        }
    });

    const {loadFavorites} = useFavorite();


    const handleSubmit = (endpointResponse, data) => {
        setGTMUserData(endpointResponse?.data?.userData);

        loadFavorites();

        if(!onSubmitCallback){
            onSubmitCallback = (endpointResponse, data) => {
                if(endpointResponse?.data?.redirect) {
                    window.location = endpointResponse.data.redirect;
                } else {
                    window.location = DASHBOARD;
                }
            }
        }

        onSubmitCallback(endpointResponse, data);
    }

    return (
        <Form onSubmit={onSubmit(handleSubmit)}>
            <InputContainer>
                <Input
                    label={"Email Address"}
                    placeholder={"Email Address"}
                    fullWidth
                    {...register("email")}
                    errorMessage={state?.errors?.email?.message ?? ''}
                />
            </InputContainer>

            <InputContainer>
                <PasswordInput
                    label={"Password"}
                    placeholder={"Password"}
                    fullWidth
                    {...register("password")}
                    errorMessage={state?.errors?.password?.message ?? ''}
                />
            </InputContainer>

            <LoadingButton
                loading={isLoading}
                disabled={!isValid}
                variant="contained"
                type="submit"
                size="medium"
            >
                Continue →
            </LoadingButton>
        </Form>
    );
};
